import { useTranslation } from 'react-i18next';
import {
  Input,
  RadioGroup,
  SingleSelect,
  Textarea,
  Widget,
} from '@asset-metrix/portal-ui';
import { Stack } from '@mantine/core';

import {
  limitModeOptions,
  LimitSetupDraft,
  LimitType,
} from './createInvestmentLimitModel';
import { limitModeCards, limitTypeSelectData } from './investmentLimitLabels';

import styles from './createInvestmentLimitModal.module.scss';

export type OverviewStepProps = {
  draft: LimitSetupDraft;
  onDraftChange: (update: Partial<LimitSetupDraft>) => void;
};

export function OverviewStep({ draft, onDraftChange }: OverviewStepProps) {
  const { t } = useTranslation();

  // Inclusing limits are not creatable in the first iteration of these feature.
  const creatableLimitModes = limitModeCards(t).filter(
    (option) => option.value !== 'Inclusion'
  );

  return (
    <Stack className={styles['modal-step']}>
      <Widget title={t('app.investmentLimit.widgets.overview')}>
        <div className={styles['modal-card-content']}>
          <RadioGroup
            direction="row"
            label={t('app.investmentLimit.preview.limitMode')}
            name="investment-limit-mode"
            onChange={(value) => {
              const limitMode = limitModeOptions.find(
                (option) => option.value === value
              )?.value;
              if (limitMode) {
                onDraftChange({ limitMode });
              }
            }}
            options={creatableLimitModes}
            value={draft.limitMode}
            variant="cards"
          />
          <Input
            label={t('app.investmentLimit.fields.limitName')}
            onChange={(value) => onDraftChange({ limitName: value })}
            placeholder={t('app.investmentLimit.fields.limitNamePlaceholder')}
            required
            value={draft.limitName}
          />
          <Textarea
            autosize
            label={t('app.investmentLimit.fields.description')}
            minRows={3}
            onChange={(value) => onDraftChange({ description: value })}
            placeholder={t('app.investmentLimit.fields.descriptionPlaceholder')}
            value={draft.description}
          />
          <SingleSelect<LimitType>
            clearable={false}
            data={limitTypeSelectData(t)}
            label={t('app.investmentLimit.fields.limitType')}
            onChange={(value) => onDraftChange({ limitType: value })}
            placeholder={t('app.investmentLimit.fields.selectType')}
            required
            value={draft.limitType}
          />
        </div>
      </Widget>
    </Stack>
  );
}
